export var ListFormat;
(function (ListFormat) {
    ListFormat[ListFormat["None"] = 0] = "None";
    ListFormat[ListFormat["Bullet"] = 1] = "Bullet";
    ListFormat[ListFormat["Numbered"] = 2] = "Numbered";
})(ListFormat || (ListFormat = {}));
